import { useAtomValue } from 'jotai';
import { openFloatingChat } from '@fiverr-private/go_floating_chat_triggers';
import { FederatedSeller } from '../types';
import { floatingChatDataAtom } from '../atoms';
import { useSellerData } from './useSellerData';
import { useIsSellerOnline } from './useIsSellerOnline';

export const useFloatingChatTrigger = () => {
    const { displayName, username, profileImageUrl, sellerId } = useSellerData(selectSellerSlice);
    const { isFloatingChatEnabled, showConversationSavedTooltip } = useAtomValue(floatingChatDataAtom);
    const isOnline = useIsSellerOnline();
    return {
        isFloatingChatEnabled,
        openFloatingChat: () =>
            openFloatingChat({
                data: {
                    recipientUsername: username,
                    showConversationSavedTooltip,
                    seller: {
                        username,
                        name: displayName || undefined,
                        imageSrc: profileImageUrl || undefined,
                        isOnline,
                    },
                    initialData: {
                        sellerId,
                        entryPoint: 'seller',
                    },
                },
            }),
    };
};

function selectSellerSlice(seller: FederatedSeller) {
    return {
        approvedGigsCount: seller.approvedGigsCount,
        username: seller.user.name,
        displayName: seller.user.profile.displayName,
        isActivationCompleted: seller.user.isActivationCompleted,
        profileImageUrl: seller.user.profileImageUrl,
        sellerId: seller.user.id,
    };
}
